import customAxios from './axios';
import CONFIG from '../../config';

export const get = (jobID) => {
    return customAxios.get(CONFIG.apiURL + `/Jobs/JobDetails?JobId=${jobID}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const create = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/Jobs/Create', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const saveAsDraft = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/Jobs/CreateDraft', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const update = (payload, jobAction) => {
    return customAxios.put(CONFIG.apiURL + `/Jobs/Update?jobAction=${jobAction}`, payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const paymentCompleted = (jobID) => {
    return customAxios.post(CONFIG.apiURL + `/Jobs/PaymentCompleted?jobID=${jobID}&type=authorised`).then(res => {
        let response = res['data'];
        return response;
    })
};